import { UrgencyBarColor } from '@hyphengroup/cms-components/components/UrgencyBar';
import { ExclusiveOfferBadgeColorEnum } from '__generated__/graphql.enums';

export const urgencyBarColorMapper: Partial<
  Record<ExclusiveOfferBadgeColorEnum | string, UrgencyBarColor>
> = {
  [ExclusiveOfferBadgeColorEnum.Blue]: 'blue',
  [ExclusiveOfferBadgeColorEnum.Green]: 'green',
  [ExclusiveOfferBadgeColorEnum.Orange]: 'orange',
  [ExclusiveOfferBadgeColorEnum.Red]: 'red',
  [ExclusiveOfferBadgeColorEnum.Yellow]: 'yellow',
  [ExclusiveOfferBadgeColorEnum.Gray]: 'gray',
};

export const mapExclusiveOfferBadgeColorToUrgencyBarColor = (
  fallbackColor: UrgencyBarColor,
  color?: ExclusiveOfferBadgeColorEnum | string,
): UrgencyBarColor => {
  if (!color) {
    return fallbackColor;
  }
  if (!urgencyBarColorMapper[color]) {
    return fallbackColor;
  }
  return urgencyBarColorMapper[color] as UrgencyBarColor;
};
